/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Enum for the status of a request
 */
export enum RequestStatusEnum {
  /**
   * THe request is still in draft state and not yet ready to be sent to the requested party
   */
  DRAFT = "DRAFT",

  /**
   * The requesting party has requested a repair estimate from the requested party and shared the request
   */
  REQUESTED = "REQUESTED",

  /**
   * The requested party has received the request and send an affirmative reply
   * Final State for Requested.
   */
  REPLIED = "REPLIED",

  /**
   * The requesting party has confirmed that the response to the request is accepted
   */
  ACCEPTED = "ACCEPTED",

  /**
   * Status where the requested party can not accept or reject the request due to missing data
   * Explicitly NOT a final state
   */
  REQUEST_MORE_DATA = "REQUEST_MORE_DATA",

  /**
   * Status where the requested party rejected the request
   * Final State for Requested and Requesting
   */
  REJECTED_BY_REQUESTED = "REJECTED_BY_REQUESTED",

  /**
   * Status where the rejecting party rejected the offer received
   * Final State for Requested and Requesting
   */
  REJECTED_BY_REQUESTING = "REJECTED_BY_REQUESTING",

  /**
   * Status where the request is fully completed and finished
   * Final State for all parties
   */
  FINISHED = "FINISHED"
}

/**
 * Statuses in which a request is still open, i.e. waiting on someone to act.
 * A request in one of these statuses whose due date has passed is overdue.
 */
export const OPEN_REQUEST_STATUSES: RequestStatusEnum[] = [
  RequestStatusEnum.DRAFT,
  RequestStatusEnum.REQUESTED,
  RequestStatusEnum.REQUEST_MORE_DATA
];
